<script setup>
import IconArrowUpRight from "@components/icons/ArrowUpRight.vue";
import Button from "@components/Button.vue";
import { useTriviaStore } from "@stores/trivia";
import { useGlobalStore } from "@stores/global";
import IconFinish from "@components/icons/Finish.vue";

const triviaStore = useTriviaStore();
const globalStore = useGlobalStore();
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="triviaStore.gameState === 'intro'"
            class="trivia-intro bg-marine-800 border-marine-500 relative isolate flex flex-col items-start justify-between gap-6 border-r border-b px-6 py-8 lg:gap-0"
        >
        <div class="flex flex-col gap-0.5">
            <p class="body-sm font-bold uppercase">Mini Game</p>
            <p
                class="h2 trivia-intro--title leading-none font-extrabold text-yellow-400 uppercase"
            >
                Trivia
            </p>
        </div>
        <p class="body-lg">
            Can you guess where Speed travelled?<br />
            How close can you get?
        </p>
        <div class="flex gap-2.5">
            <button
                class="border-marine-500 flex size-12 items-center justify-center border lg:hidden"
                @click="globalStore.togglePanel('trivia')"
            >
                <span class="sr-only">Leaderboard</span>
                <IconFinish class="size-4 text-yellow-400" />
            </button>
            <Button
                :disabled="triviaStore.loading"
                @click="triviaStore.startGame()"
            >
                {{ triviaStore.loading ? "Loading…" : "Start now" }}
            </Button>
            <IconArrowUpRight
                class="absolute top-4 right-4 h-5 text-yellow-400"
            />
        </div>
    </div>
    </Transition>
</template>

<style scoped>
.trivia-intro {
    grid-column: 2 / 9;
    grid-row: max(4, round((var(--rows) - 2) / 2, 1)) / span 4;
    z-index: 2;
}
@media (max-width: 1024px) {
    .trivia-intro {
        grid-column: 1 / -1;
        grid-row: -4 / -1;
        align-self: end;
    }
}
.trivia-intro--title {
    text-shadow: 0 0.1607em 0 var(--marine-base, #19233b);
    -webkit-text-stroke-width: 0.1071em;
    -webkit-text-stroke-color: var(--Marine-600, #19233b);
    paint-order: stroke fill;
}
</style>
